import {
  commonTableWidth,
  pageTableWidth,
  opCloWidth
} from "@/setting/setting";
export default {
  // 供应商基本信息
  supplierBaseInfo: Object.freeze([
    { label: "供应商名称", fieldName: "supName" },
    { label: "供应商简称", fieldName: "supShort" },
    { label: "供应商类型", fieldName: "supTypeNameComp" },
    { label: "是否为外贸供应商", fieldName: "isOutSupComp" },
    { label: "是否为中交内部企业", fieldName: "isInIndyComp" },
    { label: "所在区域", fieldName: "location" },
    { label: "住所", fieldName: "homeAddr" },
    { label: "办公地址", fieldName: "officeAddr" },
    { label: "邮编", fieldName: "post" },
    { label: "注册资本（万元）", fieldName: "regCapl", slot: "regCapl" },
    { label: "币种", fieldName: "moneyTypeName" },
    { label: "实收资本（万元）", fieldName: "factCapl", slot: "factCapl" },
    { label: "公司类型", fieldName: "companyTypeName" },
    { label: "成立时间", fieldName: "foundTime" },
    { label: "营业期限", fieldName: "businessValidDateStr" },
    { label: "所属集团公司名称", fieldName: "belongCompanyName" },
    { label: "国别", fieldName: "countryName" },
    { label: "注册来源", fieldName: "registSourceName" },
    { label: "账号状态", fieldName: "freeordisStateName" },
    { label: "冻结日期", fieldName: "createTimeAndThawTime" },
    // { label: "禁用日期", fieldName: "freezenCreateTime" },
    { label: "法人代表姓名", fieldName: "legalContactName" },
    { label: "经营范围", fieldName: "busiScope", filedSpan: 24 },
    {
      label: "组织架构及营销网络",
      fieldName: "orgStructMarketNet",
      filedSpan: 24
    },
    { label: "公司简介", fieldName: "companyProfile", filedSpan: 24 },
    { label: "产能", fieldName: "capacity" },
    { label: "工艺技术现状", fieldName: "processTech" },
    { label: "所代理生产商名称", fieldName: "producerName" },
    { label: "经销代理资格", fieldName: "agentQualify" }
  ]),
  /** 是三证合一时，展示工商注册号 **/
  itCredentials: Object.freeze({
    label: "统一社会信用代码",
    fieldName: "regNum"
  }),
  /** 不是三证合一时，展示组织机构代码、组织机构代码证件有效期、税号 **/
  itNotCredentials: Object.freeze([
    { label: "营业执照号", fieldName: "regNum" },
    { label: "组织机构代码", fieldName: "orgCode" },
    { label: "组织机构代码证件有效期", fieldName: "orgCredentialsValidDate" },
    { label: "税号", fieldName: "taxCode" }
  ]),
  // 供应商联系信息
  supplierContact: Object.freeze([
    { label: "法人代表手机", fieldName: "legalContactMobile" },
    { label: "法定代表固话", fieldName: "legalContactTel" },
    { label: "法定代表人传真", fieldName: "legalContactFax" },
    { label: "销售负责人", fieldName: "salesHeaderName" },
    { label: "销售负责人手机", fieldName: "salesHeaderMobile" },
    { label: "销售负责人固话", fieldName: "salesHeaderTel" },
    { label: "销售负责人传真", fieldName: "salesHeaderFax" },
    { label: "销售负责人E-mail", fieldName: "salesHeaderEmail" },
    { label: "联系人", fieldName: "contactName" },
    { label: "联系人固话", fieldName: "contactTel" },
    { label: "联系人手机", fieldName: "contactMobile" },
    { label: "联系人E-mail", fieldName: "contactEmail" },
    { label: "联系人传真", fieldName: "contactFax" },
    { label: "公司网址", fieldName: "website" }
  ]),
  //供应商常用联系人信息[表格]
  supplierCommonLinkInfo: Object.freeze([
    {
      label: "联系人",
      prop: "commonContactName",
      align: "left",
      width: commonTableWidth.publicName
    },
    {
      label: "联系人手机",
      prop: "commonContactMobile",
      align: "left",
      width: commonTableWidth.telWidth
    },
    {
      label: "联系人固定电话",
      prop: "commonContactTel",
      align: "left",
      width: commonTableWidth.phoneWidth
    },
    {
      label: "联系人传真",
      prop: "commonContactFax",
      align: "left",
      width: commonTableWidth.faxWidth
    },
    {
      label: "联系人E-mail",
      prop: "commonContactEmail",
      align: "left",
      width: commonTableWidth.email
    },
    { label: "服务范围", prop: "serviceScope", align: "left" },
    {
      label: "是否默认联系人",
      align: "left",
      prop: "isDefaultFlagName",
      width: 110
    }
  ]),
  //财务信息
  financeInfo: Object.freeze([
    { label: "银行账号", fieldName: "bankId" },
    { label: "开户银行", fieldName: "bankName" }
  ]),

  //产品信息
  productInfo: Object.freeze([
    { label: "产品名称", prop: "matcateryName", align: "left" },
    { label: "产品编码", prop: "matcateryCode", align: "left" },
    { label: "产品商标", prop: "matTrademark", align: "left" },
    { label: "备注", prop: "prodinfoRemark", align: "left" }
  ]),

  //合作业绩
  cooperationPerformance: Object.freeze([
    { label: "合作企业", fieldName: "cooperEnterprise", filedSpan: 24 },
    { label: "与中交合作业绩", fieldName: "cooperPerformIccec", filedSpan: 24 },
    {
      label: "与同类行业企业合作业绩",
      fieldName: "cooperPerformSameInd",
      filedSpan: 24
    },
    { label: "备注", fieldName: "remark", filedSpan: 24 }
  ]),
  //签订合同业绩   TODO
  signContract: Object.freeze([
    {
      label: "合作单位名称",
      prop: "fileName",
      align: "left",
      width: commonTableWidth.unitName
    },
    {
      label: "合同名称",
      prop: "fileSize",
      align: "left",
      width: pageTableWidth.contractName
    },
    {
      label: "合同编号",
      prop: "fileType",
      align: "left",
      width: pageTableWidth.contractCode
    },
    {
      label: "合同签订时间",
      prop: "fileRemark",
      align: "left",
      width: commonTableWidth.dateTimeWidth
    },
    {
      label: "合同产品目录",
      prop: "fileRemark",
      align: "left",
      width: commonTableWidth.productContents
    }
  ]),
  //资质文件
  certificates: Object.freeze([
    { label: "附件名称", prop: "fileName", align: "left" },
    {
      label: "附件大小",
      prop: "fileSize",
      slot: "size",
      align: "left",
      width: 100
    },
    { label: "附件类型", prop: "fileinfoTypeName", align: "left" },
    { label: "附件说明", prop: "fileDesc", align: "left" },
    {
      label: "操作",
      prop: "d",
      slot: "opp",
      align: "left",
      width: opCloWidth.certificatesShow
    }
  ]),
  //状态信息 TODO
  statusInfo: Object.freeze([
    {
      label: "供应商名称",
      prop: "supName",
      align: "left",
      width: commonTableWidth.supplierName
    },
    {
      label: "状态",
      prop: "stateName",
      align: "left",
      width: commonTableWidth.supplierState
    },
    {
      label: "开始时间",
      prop: "createTime",
      align: "left",
      width: commonTableWidth.dateTimeWidth2
    },
    {
      label: "结束时间",
      prop: "thawTime",
      align: "left",
      slot: "thawTime",
      width: commonTableWidth.dateTimeWidth2
    },
    {
      label: "原因",
      prop: "frozenReason",
      align: "left",
      minWidth: commonTableWidth.publicMark
    },
    {
      label: "操作人姓名",
      prop: "operName",
      align: "left",
      width: commonTableWidth.publicopName
    },
    {
      label: "附件",
      prop: "filename",
      slot: "opp",
      align: "left",
      width: commonTableWidth.minFilename
    }
  ]),
  //申请说明、变更说明
  applyState: Object.freeze([
    { label: "申请类型", fieldName: "applyTypeName", filedSpan: 24 },
    { label: "申请单位", fieldName: "applyUnitName", filedSpan: 24 },
    { label: "申请时间", fieldName: "applyTime", filedSpan: 24 },
    { label: "申请说明", fieldName: "applyRemark", filedSpan: 24 }
  ]),
  //审批记录、审批日志
  approvalRecord: Object.freeze([
    { label: "操作人", prop: "operatorName", align: "left" },
    { label: "所属单位", prop: "operatorUnitName", align: "left" },
    { label: "所属部门", prop: "operatorDeptName", align: "left" },
    { label: "操作类型", prop: "operResultTypestr", align: "left" },
    {
      label: "操作状态",
      prop: "operState",
      align: "left",
      formatter(row, column) {
        console.log(row);
        console.log(column);
        return row.operState === 1 ? "已操作" : "未操作";
      }
    },
    { label: "操作时间", prop: "operTimeString", align: "left" },
    { label: "审批结果", prop: "operResultName" },
    { label: "审批意见", prop: "operOpinion" }
  ]),
  //供应商合作单位列表
  cooperationUnit: Object.freeze([
    { label: "合作单位", prop: "coopCompanyName", align: "left" },
    { label: "合作时间", prop: "coopTime", align: "left" }
  ]),

  foreign: {
    //供应商基本信息
    supplierBaseInfo: Object.freeze([
      { label: "供应商名称", fieldName: "supName" },
      { label: "供应商简称", fieldName: "supShort" },
      { label: "供应商类型", fieldName: "supTypeNameComp" },
      { label: "供应商国别", fieldName: "countryCode" },
      { label: "注册号码", fieldName: "regNum" },
      { label: "税号", fieldName: "taxCode" },
      { label: "住所", fieldName: "homeAddr" },
      { label: "办公地址", fieldName: "officeAddr" },
      { label: "币种", fieldName: "moneyTypeName" },
      { label: "注册资本（万元）", fieldName: "regCapl" },
      { label: "成立时间", fieldName: "foundTime" },
      { label: "营业期限", fieldName: "businessValidDateStr" },
      // { label: "初始推荐单位", fieldName: "recommendIndyName" },
      {
        label: "组织架构及营销网络",
        fieldName: "orgStructMarketNet"
      },
      { label: "公司简介", fieldName: "companyProfile" },
      { label: "经营范围", fieldName: "busiScope" }
    ]),
    // 供应商联系信息
    supplierContact: Object.freeze([
      { label: "法人代表姓名", fieldName: "legalContactName" },
      { label: "销售负责人", fieldName: "salesHeaderName" },
      { label: "销售负责人手机", fieldName: "salesHeaderMobile" },
      { label: "联系人E-mail", fieldName: "contactEmail" },
      { label: "销售负责人固定电话", fieldName: "salesHeaderTel" },
      { label: "销售负责人传真", fieldName: "salesHeaderFax" },
      { label: "公司网址", fieldName: "website" }
    ]),
    //财务信息
    financeInfo: Object.freeze([
      { label: "银行账号", fieldName: "bankId" },
      { label: "开户银行", fieldName: "bankName" },
      { label: "账户名", fieldName: "accountName" },
      { label: "开户银行地址", fieldName: "accountBankAddr" },
      { label: "收款人地址", fieldName: "payeeAddr" },
      { label: "银行国际代码", fieldName: "swiftCode" },
      { label: "是否接受信用证付款", fieldName: "isAccpName", span: 24 }
    ])
  }
};
